import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';

import '../../styles/index.scss';

const DiscoveryPillBarLayout = ({leftSectionBar, rightSectionBar, className}) => {
  return (
    <section className={cs('PillBar', 'PillBar__Container', className)}>
      <div className="pill-bar-left-side">{leftSectionBar}</div>
      <div className="pill-bar-right-side-container">
        <div className="pill-bar-right-side">{rightSectionBar}</div>
      </div>
    </section>
  );
};

DiscoveryPillBarLayout.propTypes = {
  leftSectionBar: PropTypes.array,
  rightSectionBar: PropTypes.array,
  className: PropTypes.string,
};

export default DiscoveryPillBarLayout;
